module.exports = __webpack_public_path__ + "static/terra-mattress-2-148ab2e860367d68271712fea33569f3.webp";